import Banner from "./Banner";
import WebLayout from "layout/webLayout.js";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

const DonateItemSections = () => {
  const [select, setSelect] = useState("");
  const [active, setActive] = useState(null);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setSelect(e.target.value);
  };

  const handleSubmit = () => {
    let path = select;
    navigate(path);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <WebLayout>
      <Banner />
      <div className="flex justify-center items-center">
        <div className="md:w-3/5 py-24 px-8 flex justify-center items-center">
          <div className="flex flex-col gap-4 justify-center items-center">
            <p className="text-[#213874] text-[24px] font-bold text-center">
              How would you like to make this donation?
            </p>
            <div className="w-full">
              <label
                onClick={() => setActive(1)}
                className={`w-full flex justify-between border border-[#213874] py-3 px-8 min-h-[50px] rounded-3xl ${
                  active === 1 && `bg-[#d8dce4] border-[#d8dce4]`
                }`}
              >
                <p>Donate to a specific project</p>
                <input
                  onChange={handleChange}
                  type="radio"
                  checked={select === "/donate-items/category/specific-project"}
                  value="/donate-items/category/specific-project"
                  name="specific-project"
                />
              </label>
            </div>
            <div className="w-full">
              <label
                onClick={() => setActive(2)}
                className={`w-full flex justify-between border border-[#213874] py-3 px-8 min-h-[50px] rounded-3xl ${
                  active === 2 && `bg-[#d8dce4] border-[#d8dce4]`
                }`}
              >
                <p>Let us match your donation to a project</p>
                <input
                  onChange={handleChange}
                  type="radio"
                  checked={select === "/donate-items/category/connect-project"}
                  value="/donate-items/category/connect-project"
                  name="connect-project"
                />
              </label>
            </div>
            <button
              disabled={!select}
              className="w-full"
              onClick={handleSubmit}
            >
              <p className="w-full flex justify-center items-center bg-[#213874] hover:bg-[#192b5b] py-3 px-8 h-[50px] rounded-3xl text-white">
                Continue
              </p>
            </button>
          </div>
        </div>
      </div>
    </WebLayout>
  );
};

export default DonateItemSections;
